import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const PaymentLink = styled(Link)`
  text-decoration: none;
  color: inherit;
`;
